import React from 'react';

interface ButtonProps {
  title: string;
  onClick: () => void | Promise<void>;
  className?: string;
  loading?: boolean;
  disabled?: boolean;
  variant?: 'primary' | 'secondary';
  icon?: React.ReactNode;
}

export const CustomButton: React.FC<ButtonProps> = ({
  title,
  onClick,
  className = '',
  loading = false,
  disabled = false,
  variant = 'primary',
  icon,
}) => {
  const baseClasses = 'px-4 py-3 rounded-full font-bold text-base flex items-center justify-center gap-2 transition-all duration-200';
  
  const variantClasses = {
    primary: 'bg-darkGreen text-white hover:bg-opacity-90',
    secondary: 'bg-primaryBg text-darkGreen hover:bg-opacity-80',
  };

  const isDisabled = disabled || loading;

  return (
    <button
      onClick={onClick}
      disabled={isDisabled}
      className={`${baseClasses} ${variantClasses[variant]} ${
        isDisabled ? 'opacity-40 cursor-not-allowed' : 'hover:shadow-lg'
      } ${className}`}
    >
      {loading ? (
        <>
          <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
          <span>Loading...</span>
        </>
      ) : (
        <>
          {icon && <span>{icon}</span>}
          <span>{title}</span>
        </>
      )}
    </button>
  );
};